<div [ngClass]="cardClasses" (click)="onClick($event)">
  <p [ngClass]="textClasses">{{ text }}</p>
  <div [ngClass]="imgBlockClasses">
    <img [ngClass]="imgClasses" [src]="imgPath" />
  </div>
  <button (click)="onClick($event)" [ngClass]="buttonClasses">
    {{ text_button }}
  </button>
</div>
